import axiosInstance from './axiosConnector';

export interface UserSettings {
  text_color: string;
  background_color: string;
  background_opacity: number;
  font_size: number;
  text_position_y: number;
}

export async function getUserSettings(userId: number): Promise<UserSettings> {
  try {
    const response = await axiosInstance.get(`/users/${userId}/settings`);
    return response.data as UserSettings;
  } catch (error) {
    console.error('Error fetching user settings:', error);
    // Return default settings if fetch fails
    return {
      text_color: '#ffffff',
      background_color: '#000000',
      background_opacity: 0.60,
      font_size: 64,
      text_position_y: 0.75
    };
  }
}

export async function updateUserSettings(userId: number, settings: UserSettings): Promise<UserSettings> {
  try {
    const response = await axiosInstance.patch(`/users/${userId}/settings`, settings);
    return response.data as UserSettings;
  } catch (error) {
    console.error('Error updating user settings:', error);
    throw error;
  }
}